import * as React from 'react';

const portraitQuery = '(orientation: portrait)';

export function isPortrait() {
  if (typeof window === 'undefined') return false;
  return window.matchMedia(portraitQuery).matches;
}

/** Portrait is the only mobile layout. Landscape keeps the desktop columns. */
export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState(isPortrait);

  React.useEffect(() => {
    const query = window.matchMedia(portraitQuery);
    const onChange = () => setIsMobile(query.matches);
    onChange();
    query.addEventListener('change', onChange);
    return () => query.removeEventListener('change', onChange);
  }, []);

  return isMobile;
}
